module.exports = __webpack_public_path__ + "img/collectiongallery_hearts@2x.6d7a28e.jpg";